import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import OfferStatusChips from '../../OfferStatusChips';

function OfferHeader({ isPreview, offer, showUnavailableLabels = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [, setSearchParams] = useSearchParams();
  const isNotSearch = location.pathname !== '/search';

  const handleBusinessClick = (id) => {
    if (isPreview) return;
    if (isNotSearch) {
      navigate(`/search?businessId=${id}`);
      return;
    }
    setSearchParams({ businessId: id });
  };

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems={{ xs: 'stretch', md: 'flex-start' }}
      flexDirection={{ xs: 'column', md: 'row' }}
      gap={2}
      p={2}
    >
      <Box display="flex" alignItems="flex-start" flex={1} minWidth={0}>
        <Box minWidth={0}>
          <Typography variant="h5" component="h3" sx={{ overflowWrap: 'anywhere' }}>
            {`${offer.headline1}${offer.headline2 ? ' | ' + offer.headline2 : ''}`}
          </Typography>
          {!offer.hideLocation && (
            <Typography>{offer.distance || 'Global'}</Typography>
          )}
        </Box>
        <Box ml={1.5} flexShrink={0}>
          <Button sx={{ minWidth: 0, p: 0.5 }} onClick={() => handleBusinessClick(offer.businessId)}>
            <img height={36} src={offer.businessImageUrl} alt={offer.businessId} />
          </Button>
        </Box>
      </Box>
      <Box display="flex" flexWrap="wrap" justifyContent={{ xs: 'flex-start', md: 'flex-end' }} gap={1} flexShrink={0}>
        <OfferStatusChips
          active={offer.active}
          claimsRemaining={offer.claimsRemaining}
          endDate={offer.endDate}
          isPreview={isPreview}
          showUnavailableLabels={showUnavailableLabels}
          unlimitedClaims={offer.unlimitedClaims}
        />
      </Box>
    </Box>
  );
}

export default OfferHeader;
